import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Api} from '../../providers/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-new-noticia',
  templateUrl: './modal-new-noticia.component.html',
  styleUrls: ['./modal-new-noticia.component.css']
})
export class ModalNewNoticiaComponent implements OnInit {

  @Output()
  onclose = new EventEmitter();

  @Output()
  onsuccess = new EventEmitter<any>();

  @Input()
  action;

  @Input()
  item;

  id;
  contenido;
  contenido_validar;

  value = null;

  constructor(config: NgbDropdownConfig, private api: Api, private spinner: NgxSpinnerService) {
    config.autoClose = true;
  }

  ngOnInit() {
    this.id = this.item.value ? this.item.value.id : null;
    console.log(this.item);
    this.contenido_validar = this.contenido = this.item.value ? this.item.value.titulo : null;
  }

  close() {
    this.onclose.emit();
  }

  success() {
    let data = {};
    data = {
      id: this.id,
      titulo: this.contenido
    };
    this.onsuccess.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/modal-new-noticia/modal-new-noticia.component.ts